// src/routes/contentRoutes.js
import React from 'react';
import { Navigate, Route } from 'react-router-dom';

// Import content components
import ContentAnalytics from '../components/features/content/ContentAnalytics';
import ContentApprovalWorkflow from '../components/features/content/ContentApprovalWorkflow';
import ContentDetail from '../components/features/content/ContentDetail';
import ContentForm from '../components/features/content/ContentForm';
import ContentSchedule from '../components/features/content/ContentSchedule';
import ContentCalendarPage from '../pages/content/ContentCalendar';

// Import permissions check
import ProtectedRoute from '../components/auth/ProtectedRoute';

const contentRoutes = [
  <Route 
    path="content" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'content', action: 'read' }}>
        <ContentCalendarPage />
        {/* <ImprovedContentCalendar/> */}
      </ProtectedRoute>
    } 
  />,
  <Route
    path="content/create"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'content', action: 'create' }}>
        <ContentForm />
        {/* <ImprovedContentForm/> */}
      </ProtectedRoute>
    }
  />,
  <Route
    path="content/:id/edit"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'content', action: 'update' }}>
        <ContentForm />
        {/* <ImprovedContentForm/> */}
      </ProtectedRoute>
    }
  />,
  <Route
    path="content/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'content', action: 'read' }}>
        <ContentDetail />
      </ProtectedRoute>
    }
  />,
  <Route
    path="content/:id/schedule"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'content', action: 'update' }}>
        <ContentSchedule />
      </ProtectedRoute>
    }
  />,
  <Route
    path="content/:id/workflow"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'content', action: 'update' }}>
        <ContentApprovalWorkflow />
      </ProtectedRoute>
    }
  />,
  <Route
    path="content/:id/analytics"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'analytics', action: 'read' }}>
        <ContentAnalytics />
      </ProtectedRoute>
    }
  />,
  <Route path="content/*" element={<Navigate to="/content" replace />} />
];

export default contentRoutes;
